import { IonIcon } from '@ionic/react';
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
import React, { useEffect, useMemo, useState } from 'react';
import {
  TutorialVideoDto,
  TutorialVideosApi,
} from '../../services/TutorialVideosApi.service';
import { openExternalLink } from '../../utils/openExternalLink';
import './GetStartedStrip.scss';

const PAGE_SIZE = 3;

const padStep = (index: number): string => String(index + 1).padStart(2, '0');

export const GetStartedStrip: React.FC = () => {
  const [videos, setVideos] = useState<TutorialVideoDto[]>([]);
  const [page, setPage] = useState(0);

  useEffect(() => {
    TutorialVideosApi.listActive()
      .then((data) => setVideos(Array.isArray(data) ? data : []))
      .catch(() => setVideos([]));
  }, []);

  const pageCount = Math.max(1, Math.ceil(videos.length / PAGE_SIZE));
  const visible = useMemo(() => {
    const start = page * PAGE_SIZE;
    return videos.slice(start, start + PAGE_SIZE);
  }, [videos, page]);

  if (videos.length === 0) return null;

  return (
    <section className="get-started-strip">
      <header className="get-started-strip-header">
        <span>Get Started</span>
        <div className="get-started-strip-nav">
          <button
            type="button"
            className="get-started-strip-arrow"
            aria-label="Previous tutorials"
            disabled={page === 0}
            onClick={() => setPage((current) => Math.max(0, current - 1))}
          >
            <IonIcon icon={chevronBackOutline} />
          </button>
          <button
            type="button"
            className="get-started-strip-arrow"
            aria-label="Next tutorials"
            disabled={page >= pageCount - 1}
            onClick={() =>
              setPage((current) => Math.min(pageCount - 1, current + 1))
            }
          >
            <IonIcon icon={chevronForwardOutline} />
          </button>
        </div>
      </header>
      <div className="get-started-strip-grid">
        {visible.map((video, index) => (
          <button
            key={video.id}
            type="button"
            className="get-started-card"
            onClick={() => openExternalLink(video.link)}
          >
            <img
              src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
              alt={video.imgAlt}
            />
            <div className="get-started-card-meta">
              <span className="get-started-card-step">
                {padStep(page * PAGE_SIZE + index)}
              </span>
              <span className="get-started-card-title">{video.imgAlt}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default GetStartedStrip;
